import { Component, Show, onMount } from "solid-js"
import { CMS } from "./cms/cms"
import { A } from "@solidjs/router"
import { createStore } from "solid-js/store";
import { SubMenu, loadCms, submenu } from "../app";
import { Sticky } from "./sticky";

type State = {
    isContentReady: boolean;
}
const Heading : Component<any> = (props) =>
<li class="static">
    <h2>
        {props.children}
    </h2>
</li>;
export const SideBar : Component<any> = (props) => {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const id = (block: string) => "1st-arc-salon/navigation::" + block;
    onMount(async () => {
        const ids = [
            id("contents"),id("introduction"),id("chairmans-message"),id("jurors"),id("sponsors"),
            id("live-exhibition"),id("artist-index"),id("about-us"),id("search"),id("awards"),
            id("best-in-show"),id("bouguereau-award"),id("peoples-choice-award"),id("other-awards"),
            id("category-awards"),id("figurative"),id("portraiture"),id("imaginative-realism"),
            id("landscape"),id("plein-air"),id("fully-from-life"),id("animals"),id("sculpture"),
            id("drawing"),id("still-life"),id("da-vinci-initiative")
        ];
        await loadCms(ids);
        setState({ isContentReady: true });
    });
    type MenuItemType = { submenu: SubMenu; label?: string; block: string; url?: string; }
    const MenuItem : Component<MenuItemType> = (props) => {
        return (
            <li classList={{ ["active"]: props.submenu == submenu() }}>
                <A href={props.url ? props.url : "/" + props.block}>
                    <CMS id={id(props.block)} text>{props.label || props.submenu}</CMS>
                </A>
            </li>
        )
    };
    return (
        <>
            <div style={{ "position": "relative" }}>
                <Sticky>
                    <div id="sidebar" style={{ "background-color": "#ecf0f1", "height": (window.innerHeight - 45) + "px" }}>
                        <section class="vertical-navigation">
                            <Show when={state.isContentReady}>
                                <ul>
                                    <Heading>
                                        <CMS id={id("contents")} text>Contents</CMS>
                                    </Heading>
                                    <MenuItem submenu="Introduction" block="introduction" />
                                    <MenuItem submenu="Chairman's Message" block="chairmans-message" />
                                    <MenuItem submenu="Jurors" block="jurors" />
                                    <MenuItem submenu="Artist Index" block="artist-index" />
                                    <MenuItem submenu="About Us" block="about-us" />
                                    <MenuItem submenu="Search" block="search" />
                                    
                                    <Heading>
                                        <CMS id={id("awards")} text>Awards</CMS>
                                    </Heading>
                                    <MenuItem submenu="Best in Show" block="best-in-show" />
                                    <MenuItem submenu="Bouguereau Award" block="bouguereau-award" />
                                    <MenuItem submenu="Other Awards" block="other-awards" />

                                    <Heading>
                                        <CMS id={id("category-awards")} text>Category Awards</CMS>
                                    </Heading>
                                    <MenuItem submenu="Figurative" block="figurative" />
                                    <MenuItem submenu="Landscape" block="landscape" />
                                    <MenuItem submenu="Animal" block="animals" />
                                    <MenuItem submenu="Sculpture" block="sculpture" />
                                    <MenuItem submenu="Drawing" block="drawing" />
                                    <MenuItem submenu="Still Life" block="still-life" />
                                </ul>
                            </Show>
                        </section>
                    </div>
                </Sticky>
            </div>
        </>
    )
}